import { gsap } from 'gsap'

export default () => {
  const customCursor = document.getElementById('cursor');

  document.addEventListener("mousemove", e => {
    gsap.set(customCursor, {
      x: e.clientX,
      y: e.clientY
    })
  });

  bindCursorHoverEffect()
  bindCursorCloseEffect()

  document.addEventListener('mouseleave', e => {
    customCursor.classList.add('cursor--hidden');
  })
  
  document.addEventListener('mouseenter', e => {
    customCursor.classList.remove('cursor--hidden');
  })
}

export function bindCursorHoverEffect() {
  const customCursor = document.getElementById('cursor');
  const hoveredElems = document.querySelectorAll('.cursor-hover');

  if (hoveredElems.length > 0) {
    hoveredElems.forEach((elem, i) => {
      elem.addEventListener('mouseenter', () => {
        customCursor.classList.remove('cursor--close');
        customCursor.classList.add('cursor--hover');
      })

      elem.addEventListener('mousedown', () => {
        
        customCursor.classList.remove('cursor--close');
        customCursor.classList.add('cursor--hover');
      })

      elem.addEventListener('mouseleave', () => {
        customCursor.classList.remove('cursor--hover');
      })
    });
  }
}

export function bindCursorCloseEffect() {
  const customCursor = document.getElementById('cursor');
  const closeElems = document.querySelectorAll('.cursor-close');

  if (closeElems.length > 0) {
    closeElems.forEach((elem, i) => {
      elem.addEventListener('mouseover', (e) => {
        if (e.target == elem) {
          customCursor.classList.remove('cursor--hover');
          customCursor.classList.add('cursor--close');
        }
      })

      elem.addEventListener('mouseout', () => {
        customCursor.classList.remove('cursor--close');
      })
    });
  }
}
